import { render, staticRenderFns } from "./NumberRow.vue?vue&type=template&id=72619a12&scoped=true"
import script from "./NumberRow.vue?vue&type=script&lang=js"
export * from "./NumberRow.vue?vue&type=script&lang=js"
import style0 from "./NumberRow.vue?vue&type=style&index=0&id=72619a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72619a12",
  null
  
)

export default component.exports